import { isNative } from "./platform";
import { applyStatusBarTheme } from "./statusBar";

/**
 * One-time native initialization: status bar theming, splash hide, push
 * registration, and share receiver. No-op on web.
 */
export async function initNativeApp(): Promise<void> {
  if (!isNative()) return;

  const prefersDark =
    typeof window !== "undefined" &&
    window.matchMedia?.("(prefers-color-scheme: dark)").matches;
  await applyStatusBarTheme(prefersDark);

  const { registerPush } = await import("./notifications");
  void registerPush();

  const { initShareReceiver } = await import("./share");
  void initShareReceiver((url) => {
    // Incoming shared file: surfaced to the app via a custom event for now.
    window.dispatchEvent(new CustomEvent("akuna:shared-file", { detail: url }));
  });

  const { SplashScreen } = await import("@capacitor/splash-screen");
  await SplashScreen.hide();
}
